import React, { useState } from "react";
import "./Layout.css";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import { Outlet } from "react-router-dom";

const Layout = () => {
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="container">
      <div className={isSidebarCollapsed ? "sidebar-collpased  " : "sidebar"}>
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setSidebarCollapsed}
        />
      </div>
      <div className={isSidebarCollapsed ? "main-collapsed " : "main-content"}>
        <Header />
        <div className="content-wrapper custom-scrollbar-mid">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
